import * as systemSelectors from "@rentiohq/web-shared/dist/redux/system/system.selectors";
import { useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";

/**
 * Whether a block's mail goes out, as its switch shows it: the stored value,
 * else the block it follows while nothing is stored, else its default. A block
 * without a switch always goes out.
 *
 * Read without a default so an unwritten preference stays distinguishable
 * from one deliberately set to the default. That difference is the whole
 * point of the fallback.
 */
export const useIsNotificationEnabled = (params: {
  enabledKey?: string;
  fallbackEnabledKey?: string;
  enabledByDefault: boolean;
}) => {
  const { enabledKey, fallbackEnabledKey, enabledByDefault } = params;

  const storedEnabled = useSelector((state: IRootStore) =>
    enabledKey
      ? systemSelectors.getPreference<boolean>(state, enabledKey)
      : undefined,
  );
  const inheritedEnabled = useSelector((state: IRootStore) =>
    fallbackEnabledKey
      ? systemSelectors.getPreference<boolean>(state, fallbackEnabledKey)
      : undefined,
  );

  return enabledKey
    ? storedEnabled ?? inheritedEnabled ?? enabledByDefault
    : true;
};
